export default {
  title: "الإعدادات",
  subtitle: "إعدادات النظام",

  breadcrumbs: {
    settings: "إعدادات الخدمات",
    configuration: "المدخلات الأساسية"
  },

  fields: {
    buyForMeRate: "نسبة اشتريلي",
    shipForMeRate: "نسبة اشحنلي",
    tax: "نسبة الضريبة",
    minimumBuyForMeCost: "الحد الأدنى لتكلفة الخدمة",
    minimumPartialPaymentPercentage: "الحد الأدنى لنسبة الدفع الجزئي (%)",
    enableBuyForMe: "تفعيل اشتريلي",
    enableShipForMe: "تفعيل اشحنلي",
    approvedOrderResetHours: "ساعات الإلغاء التلقائي للطلبات المعتمدة",
    minimumOrderWeight: "الحد الأدنى لوزن الطلب (باوند)",
    maximumOrdersPerCreate: "الحد الأقصى للمنتجات في الطلب"
  },

  placeholders: {
    buyForMeRate: "أدخل نسبة اشتريلي",
    shipForMeRate: "أدخل نسبة اشحنلي",
    tax: "أدخل نسبة الضريبة",
    minimumBuyForMeCost: "أدخل الحد الأدنى للتكلفة",
    minimumPartialPaymentPercentage: "أدخل الحد الأدنى لنسبة الدفع الجزئي",
    approvedOrderResetHours: "أدخل عدد الساعات (مثال: 72)",
    minimumOrderWeight: "أدخل الحد الأدنى للوزن بالباوند (مثال: 0.5)",
    maximumOrdersPerCreate: "أدخل الحد الأقصى لعدد المنتجات (مثال: 10)"
  },

  messages: {
    updateSuccess: "تم تحديث الإعدادات بنجاح!",
    updateError: "خطأ في تحديث الإعدادات",
    loadingError: "خطأ في تحميل الإعدادات",
    loading: "جاري تحميل تفاصيل الإعدادات..."
  },

  actions: {
    update: "تحديث الإعدادات",
    updating: "جاري التحديث...",
    back: "رجوع"
  },

  validation: {
    buyForMeRateRequired: "نسبة اشتريلي مطلوب",
    shipForMeRateRequired: "نسبة اشحنلي مطلوب",
    taxRequired: "نسبة الضريبة مطلوبة",
    minimumCostRequired: "الحد الأدنى للتكلفة مطلوب",
    invalidNumber: "يرجى إدخال رقم صحيح",
    negativeNumber: "لا يمكن أن تكون القيمة سالبة",
    maximumOrdersPerCreate: "يجب أن يكون الحد الأقصى للمنتجات عدداً صحيحاً موجباً"
  },
  onboarding: {
    title: "ترتيب خطوات الترحيب",
    subtitle: "اسحب وأسقط لتغيير ترتيب عرض الخطوات للعملاء",
    steps: {
      profile: "تحديث الملف الشخصي",
      createOrder: "إنشاء طلب",
      dashboard: "الشريط الجانبي للوحة التحكم",
      orderKinds: "معلومات أنواع الطلبات",
      orders: "شريط طلبات اشتريلي",
      shipForMe: "شريط اشحنلي"
    }
  }
};
